import { matchPath, useLocation } from '@interhyp/platform-router';
import { SET_PAGE, TRACK_PAGE_CHANGE, useTracking } from '@interhyp/util-tracking';
import { useEffect } from 'react';

/**
 * Legacy info
 * This tracking has been copied from app-interhyp-home
 */

const pathNameTrackingMap = {
  '/login': 'Login',
  '/registrierung': 'Registrierung',
  '/dashboard': 'Root Dashboard',
  '/mortgages/:intentId/dashboard': 'Dashboard',
  '/mortgages/:intentId/vorhaben': 'Vorhaben',
  '/mortgages/:intentId/vergleich': 'Vergleich',
  '/mortgages/:intentId/angebote': 'Angebote',
  '/mortgages/:intentId/unterlagen': 'Unterlagen',
};

type PathInfo = {
  path: string;
  id?: string;
  contentGroup2?: string;
  contentGroup3?: string;
};

const paths: PathInfo[] = [
  { path: '/start/termin-vereinbaren-d', id: 'Start_Termin_Vereinbaren' },
  { path: '/vergleich/termin-vereinbaren-d', id: 'Vergleich_Termin_Vereinbaren' },
  { path: 'vorhaben/ueberblick/immobilie-anlegen', id: 'Vorhaben_Überblick_Immobilie_anlegen' },
  {
    path: '/start/termin-vereinbaren-d',
    contentGroup2: 'Start_Termin_Vereinbaren',
  },
  {
    path: '/vergleich/termin-vereinbaren-d',
    contentGroup2: 'Vergleich',
    contentGroup3: 'Termin_Vereinbaren',
  },
  {
    path: '/mortgages/:intentId/vorhaben/ueberblick/immobilie-anlegen',
    contentGroup2: 'Vorhaben',
    contentGroup3: 'Überblick_Immobilie_anlegen',
  },
  {
    path: '/mortgages/:intentId/vorhaben/ueberblick/darlehensnehmer-anlegen',
    contentGroup2: 'Vorhaben',
    contentGroup3: 'Überblick_Darlehensnehmer_anlegen',
  },
  {
    path: '/mortgages/:intentId/vorhaben/ueberblick',
    contentGroup2: 'Vorhaben',
    contentGroup3: 'Überblick',
  },
  {
    path: '/mortgages/:intentId/vorhaben/immobilie/zeitplan',
    contentGroup2: 'Vorhaben',
    contentGroup3: 'Immobilie_Zeitplan',
  },
  {
    path: '/mortgages/:intentId/vorhaben/immobilie/adresse',
    contentGroup2: 'Vorhaben',
    contentGroup3: 'Immobilie_Adresse',
  },
  {
    path: '/mortgages/:intentId/vorhaben/immobilie/kosten',
    contentGroup2: 'Vorhaben',
    contentGroup3: 'Immobilie_Kosten',
  },
  {
    path: '/mortgages/:intentId/vorhaben/immobilie/grundbuch',
    contentGroup2: 'Vorhaben',
    contentGroup3: 'Immobilie_Grundbuch',
  },
  {
    path: '/mortgages/:intentId/vorhaben/darlehensnehmer/anschrift',
    contentGroup2: 'Vorhaben',
    contentGroup3: 'Darlehensnehmer_Anschrift',
  },
  {
    path: '/mortgages/:intentId/vorhaben/darlehensnehmer/haushalt',
    contentGroup2: 'Vorhaben',
    contentGroup3: 'Darlehensnehmer_Haushalt',
  },
  {
    path: '/mortgages/:intentId/vorhaben/darlehensnehmer/beruf',
    contentGroup2: 'Vorhaben',
    contentGroup3: 'Darlehensnehmer_Beruf',
  },
  {
    path: '/mortgages/:intentId/vorhaben/finanzen/einnahmen',
    contentGroup2: 'Vorhaben',
    contentGroup3: 'Finanzen_Einnahmen',
  },
  {
    path: '/mortgages/:intentId/vorhaben/finanzen/ausgaben',
    contentGroup2: 'Vorhaben',
    contentGroup3: 'Finanzen_Ausgaben',
  },

  // new Intent-Service URL
  {
    path: '/mortgages/:intentId/vorhaben-neu/',
    contentGroup2: 'Vorhaben-Neu',
  },
  {
    path: '/mortgages/:intentId/vorhaben-neu/ueberblick',
    contentGroup2: 'Vorhaben-Neu',
    contentGroup3: 'Überblick',
  },
  {
    path: '/mortgages/:intentId/vorhaben-neu/ueberblick/immobilie-anlegen',
    contentGroup2: 'Vorhaben-Neu',
    contentGroup3: 'Überblick_Immobilie_anlegen',
  },
  {
    path: '/mortgages/:intentId/vorhaben-neu/ueberblick/darlehensnehmer-anlegen',
    contentGroup2: 'Vorhaben-Neu',
    contentGroup3: 'Überblick_Darlehensnehmer_anlegen',
  },
  {
    path: '/mortgages/:intentId/vorhaben-neu/immobilie/:id/zeitplan',
    contentGroup2: 'Vorhaben-Neu',
    contentGroup3: 'Immobilie_Zeitplan',
  },
  {
    path: '/mortgages/:intentId/vorhaben-neu/immobilie/:estateId/adresse',
    contentGroup2: 'Vorhaben-Neu',
    contentGroup3: 'Immobilie_Adresse',
  },
  {
    path: '/mortgages/:intentId/vorhaben-neu/immobilie/:estateId/kosten',
    contentGroup2: 'Vorhaben-Neu',
    contentGroup3: 'Immobilie_Kosten',
  },
  {
    path: '/mortgages/:intentId/vorhaben-neu/immobilie/:estateId/grundbuch',
    contentGroup2: 'Vorhaben-Neu',
    contentGroup3: 'Immobilie_Grundbuch',
  },
  {
    path: '/mortgages/:intentId/vorhaben-neu/darlehensnehmer/anschrift',
    contentGroup2: 'Vorhaben-Neu',
    contentGroup3: 'Darlehensnehmer_Anschrift',
  },
  {
    path: '/mortgages/:intentId/vorhaben-neu/darlehensnehmer/haushalt',
    contentGroup2: 'Vorhaben-Neu',
    contentGroup3: 'Darlehensnehmer_Haushalt',
  },
  {
    path: '/mortgages/:intentId/vorhaben-neu/darlehensnehmer/beruf',
    contentGroup2: 'Vorhaben-Neu',
    contentGroup3: 'Darlehensnehmer_Beruf',
  },
  {
    path: '/mortgages/:intentId/vorhaben-neu/finanzen/einnahmen',
    contentGroup2: 'Vorhaben-Neu',
    contentGroup3: 'Finanzen_Einnahmen',
  },
  {
    path: '/mortgages/:intentId/vorhaben-neu/finanzen/ausgaben',
    contentGroup2: 'Vorhaben-Neu',
    contentGroup3: 'Finanzen_Ausgaben',
  },
];

const getTrackingInformationByLocationPath = (pathname: string): PathInfo | undefined => {
  return paths.find(dataset => matchPath(pathname, { path: dataset.path, exact: true }));
};

export function useRouteTracking(): void {
  const { pathname, search } = useLocation();
  const { trackEvent } = useTracking();

  // Track page
  useEffect(() => {
    const type = search?.includes('info=TIMEOUT') ? SET_PAGE : TRACK_PAGE_CHANGE;
    let pageName;
    let pageCategory;
    pageName = Object.entries(pathNameTrackingMap).find(page =>
      matchPath(pathname, { path: page[0], exact: true }),
    )?.[1];

    if (!pageName) {
      const result = getTrackingInformationByLocationPath(pathname);
      pageName = result?.contentGroup2;
      pageCategory = result?.contentGroup3;
    }

    trackEvent({
      type,
      payload: { pageName, pageCategory },
    });
  }, [pathname, search, trackEvent]);
}
